import React, { Component, createRef } from "react";
import { Button, IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import Loader from "../../../../loader";
import { GetProductDetails } from "../../../../services";
import { NotificationManager } from "react-notifications";
import swal from "sweetalert";

export default class NewZipUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zipFiles: [],
      isLoaded: false,
    };
    this.fileInputRef = createRef();
  }

  handleBack = () => {
    this.props.history.goBack();
  };

  onFileChange = (event) => {
    let files = Array.from(event.target.files);

    // Filter only .zip files
    const validFiles = files.filter((file) =>
      file.name.toLowerCase().endsWith(".zip")
    );

    if (validFiles.length !== files.length) {
      NotificationManager.warning(
        "Only .zip files are allowed. Invalid files were ignored.",
        "File Type Warning"
      );
    }

    this.setState({ zipFiles: [...this.state.zipFiles, ...validFiles] });
  };

  removeFile = (index) => {
    const { zipFiles } = this.state;
    const updatedFiles = zipFiles.filter((_, i) => i !== index);

    this.setState({ zipFiles: updatedFiles }, () => {
      // ✅ Reset input value when all files removed
      if (updatedFiles.length === 0 && this.fileInputRef.current) {
        this.fileInputRef.current.value = "";
      }
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { zipFiles } = this.state;

    if (!zipFiles || zipFiles.length === 0) {
      NotificationManager.error(
        "Please select at least one zip file",
        "Validation Error"
      );
      return;
    }

    this.setState({ isLoaded: true });
    const formData = new FormData();
    for (let i = 0; i < zipFiles.length; i++) {
      formData.append("zipfiles", zipFiles[i]);
    }

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    swal({
      title: "Are you sure?",
      text: "You want to upload the zip files",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        let response = await GetProductDetails.addZipFiles(formData, config);
        if (response && response.success) {
          NotificationManager.success(
            "Zip files uploaded successfully",
            "Success"
          );
          // ✅ Stay on same page, clear selection + input
          this.setState({ isLoaded: false, zipFiles: [] });
          if (this.fileInputRef.current) {
            this.fileInputRef.current.value = "";
          }
        } else {
          this.setState({ isLoaded: false });
          NotificationManager.error(
            response && response.message
              ? response.message
              : "Upload failed. Please check file names.",
            "Error"
          );
        }
      } else {
        this.setState({ isLoaded: false });
      }
    });
  };

  render() {
    const { isLoaded, zipFiles } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9 col-lg-6">
            <h2 className="mt-30 page-title">Upload Zip Files</h2>
          </div>
          <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
            <Button variant="contained" onClick={this.handleBack}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>
        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">
            <a href="/">Dashboard</a>
          </li>
          <li className="breadcrumb-item">
            <a href="/admin/product/list">Products</a>
          </li>
          <li className="breadcrumb-item active">Upload Zips</li>
        </ol>

        <div className="row">
          {isLoaded && <Loader />}
          <div className="col-lg-6 col-md-6">
            <div className="card card-static-2 mb-30">
              <div className="card-title-2">
                <h4>Add New Zip Files</h4>
              </div>
              <div className="card-body-table">
                <div className="news-content-right pd-20">
                  <div className="form-group">
                    <label className="form-label">Select Zip Files*</label>
                    <input
                      type="file"
                      className="form-control"
                      name="zipfiles"
                      multiple
                      accept=".zip"
                      ref={this.fileInputRef}
                      onChange={this.onFileChange}
                    />
                  </div>

                  {/* ✅ Display Selected Files with Remove Option */}
                  {zipFiles.length > 0 && (
                    <div className="mt-3">
                      <h6>Selected Files:</h6>
                      <ul
                        style={{ listStyleType: "disc", paddingLeft: "20px" }}
                      >
                        {zipFiles.map((file, index) => (
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "5px",
                            }}
                          >
                            {file.name}
                            <IconButton
                              size="small"
                              onClick={() => this.removeFile(index)}
                              color="secondary"
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="button_price">
                    <div className="form-group" style={{ display: "block" }}>
                      <button
                        className="save-btn hover-btn"
                        type="submit"
                        onClick={this.handleSubmit}
                      >
                        Upload Zip Files
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/fileuploads/view/index.js